import React, {useEffect, useMemo, useRef} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import fecha from 'fecha'
import deeplink from '../../../../../../../utils/deeplink'
import { IMAGE_GEEKO_LTD } from '../../../../../../../constants'
import NotificationEmpty from '../notification-empty'
import { useIntl } from 'react-intl'
import { withList } from '../../../../../../components/list'

const imageUrl = (url) =>{
    // console.log(this.model.image)
    if(url?.indexOf('http') >= 0){
        return url
    }
    return IMAGE_GEEKO_LTD + url
}

const Model1 = props => {
    useStyles(classes)
    const {model, onSensor } = props || {}

    return (
        <div className={classes.Model1}>
            <a href={deeplink(model?.deepLink, "msite")} onClick={(e) => onSensor(e)}>
                <div className={classes.ModelItem1}>
                    <div className={`${classes.ModelImg1}`}>
                        <img src={imageUrl(model?.image)}/>
                    </div>
                    <div className={classes.ModelContent1} dangerouslySetInnerHTML={{__html: model?.content}}></div>
                </div>
            </a>
        </div>
    )
}

const Model2 = props => {
    useStyles(classes)
    const {model, onSensor } = props || {}

    return (
        <div className={classes.Model2}>
            <a href={deeplink(model?.deepLink, "msite")} onClick={(e) => onSensor(e)}>
                <figure>
                    <figcaption>
                        <div dangerouslySetInnerHTML={{__html: model?.content}}></div>
                    </figcaption>

                    <img src={imageUrl(model?.image)}/>
                </figure>
            </a>
        </div>
    )
}

const Model3 = props => {
    useStyles(classes)
    const {model, onSensor } = props || {}

    return (
        <div className={classes.Model3}>
            <a href={deeplink(model?.deepLink, "msite")} onClick={(e) => onSensor(e)}>
                <div className={classes.ModelContent3} dangerouslySetInnerHTML={{__html: model?.content}}></div>
            </a>
        </div>
    )
}

const Model4 = props => {
    useStyles(classes)
    const {model, onSensor } = props || {}

    return (
        <div className={classes.Model4}>
            <a href={deeplink(model?.deepLink, "msite")} onClick={(e) => onSensor(e)}>
                <div className={classes.ModelItem4}>
                    <div className={classes.ModelBox4}>
                        <span className={classes.ModelContent4} dangerouslySetInnerHTML={{__html: model?.content}}></span>
                    </div>
                    <div className={classes.ModelText4}>
                        <span className={`${classes.ModelNum4} ${model?.num < 0 ? classes.Green: ''}`}>{model?.num < 0 ? model?.num: ('+'+model?.num)}</span>
                    </div>
                </div>
            </a>
        </div>
    )
}

const Model5 = props => {
    useStyles(classes)
    const {model, onSensor } = props || {}

    const expireDate = useMemo(() =>{
        let [beginDate, endDate] = [model?.startDate, model?.endDate]
        if(beginDate && endDate){
            return fecha.format(new Date(beginDate), 'mediumDate') + ' - ' + fecha.format(new Date(endDate), 'mediumDate')
        }
        return ''
    },[model])

    return (
        <div className={classes.Model5}>
            <a href={deeplink(model?.deepLink, "msite")} onClick={(e) => onSensor(e)}>
                <div className={classes.ModelItem5}>
                    <div className={classes.ModelBox5}>
                        <p>{model?.description}</p>
                        <div className={classes.ModelDate5}>
                            {expireDate}
                        </div>
                    </div>

                    <div className={classes.ModelContent5}>
                        <div className={classes.ModelCouponOff5}>
                            <span className={classes.CouponName5}>{model?.name}</span>
                            <span className={classes.CouponOff5}>off</span>
                        </div>
                        <span className={classes.CouponCode5}>
                            {model?.code}
                        </span>
                    </div>
                </div>
            </a>
        </div>
    )
}

const Model6 = props => {
    useStyles(classes)
    const {model, onSensor } = props || {}

    return (
        <div className={classes.Model6}>
            <a href={deeplink(model?.deepLink, "msite")} onClick={(e) => onSensor(e)}>
                <div className={classes.ModelContent6} dangerouslySetInnerHTML={{__html: model?.content}}></div>
                <div className={classes.ModelImageBox6}>
                    <div className={classes.ModelImage6}>
                        <img src={imageUrl(model?.images?.[0])}/>
                    </div>
                    <div className={classes.ModelImage6}>
                        <img src={imageUrl(model?.images?.[1])}/>
                    </div>
                    <div className={classes.ModelImage6}>
                        <img src={imageUrl(model?.images?.[2])}/>
                    </div>
                    <div className={classes.ModelImage6}>
                        <img src={imageUrl(model?.images?.[3])}/>
                    </div>
                </div>
            </a>
        </div>
    )
}

const ModelTicket = props => {
    useStyles(classes)
    const {model, onSensor, sendTime, isRead, Intl} = props || {}

    return (
        <div className={classes.TicketItem}>
            <a href={deeplink(model?.deepLink, "msite")} onClick={() => onSensor(model?.deepLink?.utmTerm || 'utmTerm 未返回')}>
                <div className={classes.TicketBox}>
                    <div className={classes.TicketHeader}>
                        <div className={classes.TicketId}>
                            <span style={{marginRight: 10}}>{Intl.formatMessage({id: 'ticket'})} ID</span>    
                            <span>{model?.targetId}</span>
                        </div>
                        <div className={classes.ticket_time} >
                            {
                                !isRead ?
                                <span className={classes.TicketNoRead}></span>:
                                <React.Fragment></React.Fragment>
                            }
                            <span className={classes.TicketSendTime}>{sendTime}</span>
                        </div>
                    </div>
                    <div className={classes.TicketContent} dangerouslySetInnerHTML={{__html: model?.content}}></div>
                </div>
            </a>
        </div>
    )
}

const NotificationList = withList(props => {
    useStyles(classes)

    const {notifications, loading, finished, getData} = props
    // console.log(props)
    const listBox = useRef()
    const Intl = useIntl()

    const clickSensor = (utm) => {
        // alert(utm)
        if(window.GeekoSensors){
            window.GeekoSensors.Track('StationMsg', {
                type: '消息中心',
                action:"click",
                message_id:utm
            })
        }
    }

    // useEffect(() => {
    //     window.addEventListener("scroll", scrollHandle)

    //     return () => {
    //         window.removeEventListener("scroll", scrollHandle)
    //     }
    // }, [])

    // const scrollHandle = (event) => {
    //     const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
    //     const documentHeight = document.body.clientHeight
    //     const windowHeight = window.innerHeight
    //     // && !!!finished
    //     if(windowHeight + scrollTop + 300 > documentHeight && !!!loading && !!!finished){
    //        getData()
    //     }
    // }

    return(
        <div className={`${classes.NotificationList}`} ref={listBox}>
            {
                notifications?.map((notification, index) => {
                    const sendTime = fecha.format(new Date(notification?.sendTime), 'mediumDate')
                    return (
                        <div className={`${classes.NotificationListItem} ${notification?.read ? classes.NotificationRead: ''} ${notification?.type != 9 ? classes.NotificationTop: ''}`} key={sendTime+index}>
                            {
                                notification?.type != 9 ?
                                <React.Fragment>
                                    <div className={classes.Time}>{sendTime}</div>
                                    <div className={`${classes.ModelBox} ${!notification?.read? classes.ModelNoRead: ''}`}>
                                        {
                                            notification?.model?.type == 1 ?
                                            <Model1 model={notification?.model} onSensor={(utm) => clickSensor(utm)}/>:
                                            notification?.model?.type == 2 ?
                                            <Model2 model={notification?.model} onSensor={(utm) => clickSensor(utm)}/>:
                                            notification?.model?.type == 3 ?
                                            <Model3 model={notification?.model} onSensor={(utm) => clickSensor(utm)}/>:
                                            notification?.model?.type == 4 ?
                                            <Model4 model={notification?.model} onSensor={(utm) => clickSensor(utm)}/>:
                                            notification?.model?.type == 5 ?
                                            <Model5 model={notification?.model} onSensor={(utm) => clickSensor(utm)}/>:
                                            <Model6 model={notification?.model} onSensor={(utm) => clickSensor(utm)}/>
                                        }
                                    </div>
                                </React.Fragment>:
                                <React.Fragment>
                                    <div className={`${classes.ModelBox} ${classes.ModelTicketBox}`}>
                                        {
                                            notification?.model?.type == 3?
                                            <ModelTicket
                                                model={notification?.model}
                                                onSensor={(utm) => clickSensor(utm)} sendTime={sendTime} 
                                                isRead={notification?.read}
                                                Intl={Intl}
                                                />:
                                            <React.Fragment></React.Fragment>
                                        }
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    )
                })
            }
            {
                !notifications || notifications?.length == 0 ?
                <NotificationEmpty/>:
                <React.Fragment></React.Fragment>
            }
        </div>
    )
})

export default NotificationList